import { useHilStore } from '../store/hilStore.js';
import type { HilEvent } from '../types/hil.types.js';

const HilEngine = {
  pushEvent(event: HilEvent): void {
    useHilStore.getState().pushHilEvent(event);
  },

  resolveEvent(eventId: string): void {
    useHilStore.getState().resolveHilEvent(eventId);
  },

  getActiveEvent(): HilEvent | null {
    return useHilStore.getState().activeEvent;
  },

  getPendingCount(): number {
    return useHilStore.getState().pendingEvents.length;
  },
};

export { HilEngine };
